import { render, staticRenderFns } from "./authorDetail.vue?vue&type=template&id=187a2da8&scoped=true&"
import script from "./authorDetail.vue?vue&type=script&lang=js&"
export * from "./authorDetail.vue?vue&type=script&lang=js&"
import style0 from "./authorDetail.vue?vue&type=style&index=0&id=187a2da8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187a2da8",
  null
  
)

export default component.exports